import { render, staticRenderFns } from "./ytgcsjf.vue?vue&type=template&id=4670a54e&"
import script from "./ytgcsjf.vue?vue&type=script&lang=js&"
export * from "./ytgcsjf.vue?vue&type=script&lang=js&"
import style0 from "./ytgcsjf.vue?vue&type=style&index=0&id=4670a54e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports